import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 4.485a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 1 0 0-16.5m-9.75 8.25c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75-9.75-4.365-9.75-9.75M12 7.985a.75.75 0 0 1 .75.75v5.416a.75.75 0 1 1-1.5 0V8.735a.75.75 0 0 1 .75-.75m-.75 9.166a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.007a.75.75 0 0 1-1.284.527.75.75 0 0 1-.223-.534z"
}));
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;